/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ProductObjectDetailPage = lazyLoad(
  () => import('./index'),
  module => module.ProductObjectDetailPage
);
